import { switchToPaymentMethodsStep } from '@/store/affiliate/stepsSlice';
import { useAffiliateDispatch, useAffiliateSelector } from '@/store/affiliate';

import { type Plan } from '@/utils/mapProductObject';
import { onCardFormSubmit } from '@/utils/stripe/affiliateOrderSubmitAdapter';

import CardFormScreen from '@/components/new-order/CardFormScreen/CardFormScreen';

const CardFormScreenAdapter = () => {
  const { isSubmitting, selectedPlan, couponDiscountPercentage, isWebRoute } = useAffiliateSelector((state) => ({
    isSubmitting: state.isSubmitting,
    selectedPlan: state.plans.selectedPlan as Plan,
    couponDiscountPercentage: state.plans.selectedPlan?.savePercentage,
    isWebRoute: state.flags.isWebRoute,
  }));
  const dispatch = useAffiliateDispatch();
  const onBackButtonClick = () => dispatch(switchToPaymentMethodsStep());

  return (
    <CardFormScreen
      selectedPlanBlockData={{ selectedPlan, couponDiscountPercentage }}
      isSubmitting={isSubmitting}
      isWebRoute={isWebRoute}
      onBackButtonClick={onBackButtonClick}
      onCardFormSubmit={onCardFormSubmit}
    />
  );
};

export default CardFormScreenAdapter;
